import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";

interface InlineTextInputProps {
  label: string;
  name: string;
  type?: string;
  value?: string | Dayjs;
  textFieldType?: "text" | "date";
  onChange?: (name: string, value: string) => void;
  errors?: Record<string, string>;
  styleClass?: string;
  minDate?: string;
  disabled?: boolean;
  isDisabledDate?: boolean;
}

const signature_fields = ["dateManagerSign", "dateHrSign", "signatureDate"];

function InlineDateField({
  label,
  name,
  value = "",
  onChange,
  errors = {},
  styleClass = "",
  minDate,
  disabled = false,
  isDisabledDate = false,
}: InlineTextInputProps) {
  const handleDateChange = (date: any, dateString: string | string[]) => {
    const formatted =
      typeof dateString === "string" ? dateString : dateString[0];
    onChange?.(name, formatted);
  };

  // const disabledDate = (current: Dayjs | null) => {
  //   return current && current > dayjs().endOf("day");
  // };

  const disabledDate = (current: Dayjs | null) => {
    if (!current) return false;

    const isAfterToday = current > dayjs().endOf("day");

    const isBeforeMinDate =
      !!minDate && current < dayjs(minDate, "DD-MM-YYYY").startOf("day");

    return isAfterToday || isBeforeMinDate;
  };

  // useEffect(() => {
  //   if (signature_fields.includes(name) && !value) {
  //     // const today = dayjs().format("YYYY-MM-DD");
  //     const today = dayjs().format("DD-MM-YYYY");
  //     onChange?.(name, today);
  //   }
  // }, []);

  return (
    <div className="mb-2 d-flex gap-2 align-items-cente inline-text-container">
      <div className={"d-flex flex-column gap-0"}>
        <label
          className="col-form-label text-nowrap"
          htmlFor={name}
          style={{ fontWeight: "600" }}
        >
          {label}
        </label>
      </div>
      {/* <div className="col-7 col-sm-5 col-md-4 d-flex flex-column "> */}
      <div className="flex-1 d-flex flex-column" style={{ minWidth: 0 }}>
        <DatePicker
          name={name}
          style={{
            width: "100%",
            minWidth: "170px",
            padding: "0.4rem 0.5rem",
          }}
          // style={{ width: "200px" }}
          className={`p1 ps-2 form-control d-inline datetimepicker inline col-4`}
          value={value ? dayjs(value, "YYYY-MM-DD") : null}
          // value={value ? dayjs(value, "DD-MM-YYYY") : null}
          format={{
            format: "DD-MM-YYYY",
            type: "mask",
          }}
          placeholder="DD-MM-YYYY"
          onChange={handleDateChange}
          disabled={disabled}
          disabledDate={(current) => isDisabledDate && disabledDate(current)}
        />

        {errors[name]?.length > 0 && (
          <p className="flex-1 text-danger ps-1 fs-12 ">{errors[name]}</p>
        )}
      </div>
    </div>
  );
}

export default InlineDateField;
